<template lang="html">
  <div>
    <b-modal ref="modal-login" centered hide-footer no-close-on-backdrop no-close-on-esc modal-class="modal-user-access-layout" @hide="$parent.openedModal = null;" title="Entrar en tu cuenta">
      <div class="box-sm-title">
        <h6><span>Selecciona tu tipo de cuenta.</span></h6>
      </div>

      <div class="box-account-types">
        <div class="col-6 col-type col-user" v-bind:class="{ active: accType == 'user' }" @click="accType = 'user'">
          <div class="box">
            <div>
              <h5>Usuario</h5>
              <h6>Ingresar como Usuario</h6>
            </div>
          </div>
        </div>

        <div class="col-6 col-type col-employer" v-bind:class="{ active: accType == 'employer' }" @click="accType = 'employer'">
          <div class="box">
            <div>
              <h5>Empleador</h5>
              <h6>Ingresar como Empresa</h6>
            </div>
          </div>
        </div>
      </div>

      <div class="box-form">
        <b-form @submit="onSubmitLogin">
          <div class="row">

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Correo*"
                label-for="il-1">
                <b-form-input
                  id="il-1"
                  size="sm"
                  v-model="formLogin.email"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Contraseña*"
                label-for="il-2">
                <div class="eye-box">
                  <b-form-input
                    id="il-2"
                    size="sm"
                    v-model="formLogin.password"
                    type="password"
                    required
                  ></b-form-input>
                  <i class="fas ic-eye" v-bind:class="{ 'fa-eye' : showpass, 'fa-eye-slash' : !showpass }"  @click="showpass = !showpass"></i>
                </div>
              </b-form-group>
            </div>
            <div class="col-12" v-if="form_errors == true">
                <small style="color:red">Credenciales incorrectas</small>
            </div>

            <div class="col-12 col-bottom">
              <div class="row align-items-center">
                <div class="col-sm-6 col-btn">
                  <b-button type="submit" class="btn-cur-1 lg" v-if="loadinglogin == false">Ingresar</b-button>
                  <img src="/public/images/shared/loading.gif" style="width: 100px;" v-else>
                </div>

                <div class="col-sm-6 col-links">
                  <a @click="toggleModal()">¿Olvidaste tu contraseña?</a>
                </div>
              </div>
            </div>

          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{
      accType: 'user',

      formLogin: {
        email: null,
        password: null,
        type:null
      },
      form_errors:false,
      loadinglogin:false,
      showpass:false,
    }
  },

  methods: {
    toggleModal(){
      this.$refs['modal-login'].hide();
      setTimeout( ()=>{ this.$parent.openedModal = 'resetPass'; }, 200);
    },

    onSubmitLogin(event) {
        event.preventDefault();
        this.loadinglogin = true;
        this.form_errors = false;
        this.formLogin.type = this.accType;
        axios.get(tools.url('/sanctum/csrf-cookie')).then(() => {
          axios.post(tools.url("/loginFront"),this.formLogin).then((response)=>{
              this.$root.user = response.data;
              if (this.$root.user.roles[0].name == 'empresa') {

                  this.$root.logged=true;
                  this.$root.type_logged = 'empresa';
                  this.$parent.openedModal = null;
                  this.$refs['modal-login'].hide();
                  this.$router.push('/cuenta-empresa');
              }
              else if(this.$root.user.roles[0].name == 'cliente'){
                   this.$root.user = response.data;
                  this.$root.logged=true;
                  this.$root.type_logged = 'usuario';
                  this.$parent.openedModal = null;
                  this.$refs['modal-login'].hide();
                  this.$router.push('/cuenta-usuario');

              }

              this.loadinglogin = false;
              //location.reload();

          }).catch((error)=>{

              this.form_errors = true;
              this.loadinglogin = false;
          });
        });

        //console.log('Login...');
    },
  },

  watch: {
    'showpass':function (val) {
          if (val == true) {
              $("#il-2").prop('type','text');
          }
          else if (val == false) {
            $("#il-2").prop('type','password');
          }
      },
    '$parent.openedModal': function (val, oldVal) {
      if(val == 'loginemployer'){
        this.accType = 'employer';
        this.$refs['modal-login'].show();
      }
      else if(val == 'loginuser'){
          this.accType = 'user';
          this.$refs['modal-login'].show();
      }
    }
  },

  mounted(){
    // this.$refs['modal-login'].show();
  },
}
</script>
